import { useState } from "react";
import ImagePopup from "../common/Modals/ImagePopup";

// portfolio_data
const portfolio_data = [
  {
    index: 0,
    tag: "Entertainment & Publishing",
    category: "Entertainment & Publishing",
    otherImages: [
      {
        id: 1,
        img: "/assets/img/project/6.png",
        name: "The Co-Parenting Planner",
        col: 6,
      },
      {
        id: 2,
        img: "/assets/img/project/id2.png",
        name: "Adventures of Maddie",
        col: 6,
      },
    ],
  },
  {
    index: 1,
    tag: "Data Analysis",
    category: "Beauty & Merch",
    otherImages: [
      {
        id: 1,
        img: "/assets/img/project/keepitclassynails.png",
        name: "The Co-Parenting Planner",
        col: 6,
      },
    ],
  },
  {
    index: 2,
    tag: "Business",
    category: "Evan Grace Media",
    otherImages: [
      {
        id: 1,
        img: "/assets/img/project/Just Monyetta Youtube.png",
        name: "Just Monyetta Youtube",
        col: 3,
      },
      {
        id: 2,
        img: "/assets/img/project/Evan Grace Music Group.png",
        name: "Evan Grace Music Group (PENDING)",
        col: 3,
      },
      {
        id: 3,
        img: "/assets/img/project/Linda B's Grace Foundation.png",
        name: "Linda B's Grace Foundation",
        col: 3,
      },
      {
        id: 4,
        img: "/assets/img/project/Heels of Greatness.png",
        name: "Heels of Greatness",
        col: 3,
      },
      {
        id: 5,
        img: "/assets/img/project/5.png",
        name: "Keep It Classy Convos",
        col: 3,
      },
    ],
  },
  {
    index: 3,
    tag: "Product Design",
    category: "Carter Trading Group",
    otherImages: [
      {
        id: 1,
        img: "/assets/img/project/Newgate Global Resources.png",
        name: "Newgate Global Resources",
        col: 6,
      },
    ],
  },
];

// categories
const categories = [...new Set(portfolio_data.map(item => item.category))];

const PortfolioThree = () => {
  const [isActive, setIsActive] = useState("Entertainment & Publishing");
  const [portfolioItems, setPortfolioItems] = useState(
    portfolio_data.filter(
      item => item.category === "Entertainment & Publishing"
    )
  );

  // photoIndex
  const [photoIndex, setPhotoIndex] = useState(0);
  // image open state
  const [isOpen, setIsOpen] = useState(false);

  // handleImagePopup
  const handleImagePopup = i => {
    setPhotoIndex(i);
    setIsOpen(true);
  };

  const handlePortfolioData = category => {
    setIsActive(category);
    setPortfolioItems(
      portfolio_data.filter(item => item.category === category)
    );
  };

  return (
    <>
      {/* <!-- portfolio area start  --> */}
      <div className="tp-portfolio-area">
        <div className="container p-0">
          <div className="tp-portfolio-header mb-70">
            <div className="col align-items-center g-0">
              <div className="col-12 text-center">
                <div className="tp-portfolio-info">
                  <div className="tp-portfolio-subtitle mb-15">
                    <span>Our Diverse Portfolio</span>
                  </div>
                  <h3 className="tp-portfolio-title">
                    Brands Under The Evan Grace Group
                  </h3>
                </div>
              </div>
              <div className="col-12 text-center">
                <div className="tp-pf-btn mt-35">
                  <div className="row justify-content-center">
                    {categories.map((cate, i) => (
                      <div key={i} className="col-auto mb-2">
                        <button
                          onClick={() => handlePortfolioData(cate)}
                          className={`${isActive === cate ? "active" : ""}`}
                          style={{
                            color: isActive === cate ? "#0ABAB5" : "inherit",
                          }}
                        >
                          {cate.split("-").join(" ").toUpperCase()}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row tp-portfolio-active">
            <div className="col-lg-12">
              <div className="row">
                {portfolioItems.map(item =>
                  item.otherImages.map((image, imageIndex) => (
                    <div
                      key={image.id}
                      className={`col-lg-${image.col} tp-portfolio-item w-img mb-4`} // Added mb-4 for bottom margin
                    >
                      <div className="fix">
                        <div
                          className="image-container"
                          onClick={() => handleImagePopup(imageIndex)}
                        >
                          <img src={image.img} alt={image.name} />
                          <div className="overlay">
                            <span>{image.name}</span> {/* Display image name */}
                          </div>
                        </div>
                      </div>
                      <div className="portfolio-tag">
                        <a href="#">
                          <span>{item.tag}</span>
                        </a>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <div className="text-center mb-reset mt-70 mb-140">
            <a href="#" className="tp-btn-border">
              Explore More
              <span>{/* SVG code here */}</span>
            </a>
          </div>
        </div>
      </div>
      {/* <!-- portfolio area end  --> */}

      {/* image light box start */}
      {isOpen && (
        <ImagePopup
          images={portfolioItems.flatMap(item =>
            item.otherImages.map(img => img.img)
          )}
          setIsOpen={setIsOpen}
          photoIndex={photoIndex}
          setPhotoIndex={setPhotoIndex}
        />
      )}
      {/* image light box end */}

      <style jsx>{`
        .image-container {
          position: relative;
          overflow: hidden;
        }

        .image-container img {
          width: 100%;
          height: auto;
          display: block;
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .image-container:hover .overlay {
          opacity: 1; /* Show overlay on hover */
        }
      `}</style>
    </>
  );
};

export default PortfolioThree;
